var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clear"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 10,
    cy: 10.6606,
    r: 10,
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 275",
    x: 6.4209,
    y: 6.28564,
    width: 11.2494,
    height: 1.12494,
    rx: 0.562471,
    transform: "rotate(45 6.4209 6.28564)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 276",
    width: 11.2494,
    height: 1.12494,
    rx: 0.562471,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 13.5791 6.28564)",
    fill: "#757575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClear);
export default __webpack_public_path__ + "static/media/ic_clear.35d16b6f99312b3c5158a67c2d30d9e8.svg";
export { ForwardRef as ReactComponent };